import React, { useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import styles from './OffScreenPanel.module.css';

export const OffScreenPanel = (props) => {
  const [open, toggleVisibility] = useState(false);
  const toggle = () => toggleVisibility(!open);
  props.onOpen && props.onOpen();

  return (
    <div className={classNames('offScreenPanel', {
      [styles.open]: open
    })}>
      <button type="button" className={styles.button} onClick={toggle}>
        {props.buttonBody}
      </button>
      <div className={styles.panel}>
        <div className={styles.body}>{open && props.children}</div>
      </div>
      <div role="presentation" className={styles.overlay} onClick={toggle} />
    </div >
  );
};

OffScreenPanel.propTypes = {
  children: PropTypes.any,
  buttonBody: PropTypes.any,
  onOpen: PropTypes.func,
};

export default OffScreenPanel;